import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === "development",
    fallbackLng: "ar",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          storiesForLife: "Stories for Life",
          stories: "Stories",
          submit: "Submit",
          message: "Message",
          name: "Name",
          firstName: "First Name",
          male: "Male",
          female: "Female",
          gender: "Gender",
          country: "Country",
          city: "City or Region",
          contactUs: "Contact Us",
          whatsapp: "WhatsApp Number",
          region: "What region do you live in?",
          selectRegion: "Select a region",
          eastAmman: "East Amman",
          westAmman: "West Amman",
          zarqa: "Zarqa",
          irbid: "Irbid",
          balqa: "Balqa",
          mafraq: "Mafraq",
          jerashOrAjloun: "Jerash or Ajloun",
          madaba: "Madaba",
          karak: "Karak",
          maan: "Ma'an",
          tafilah: "Tafilah",
          aqaba: "Aqaba",
          outsideOfJordan: "Outside of Jordan",
          questionsOrComments: "Do you have questions or comments? Tell us:",
          termsAndConditions: "Terms & Conditions",
          privacyPolicy: "Privacy Policy",
          addToHomescreen: "Add to Home Screen",
          share: "Share Website",
          whatsappPermission: "We'll talk with you on WhatsApp about your comment",
          contactFooter: "Want to talk about something you heard here?",
          contactResponseDelay: "Please give us up to 5 days to reply"
        },
      },
      ar: {
        translation: {
          storiesForLife: "قصص للحياة",
          stories: "القصص",
          submit: "تسجيل",
          message: "الرسائل",
          name: ":الاسم",
          firstName: "اسمك الأول",
          male: "ذكر",
          female: "انثى",
          gender: "الجنس",
          country: "البلد",
          city: ":المدينة أو المنطقة",
          contactUs: "تواصل معنا",
          whatsapp: "رقم الواتس اب",
          region: "ساكن بأي محافظة؟",
          selectRegion: "اختر منطقة",
          eastAmman: "شرق عمّان",
          westAmman: "غرب عمّان",
          zarqa: "الزرقاء",
          irbid: "إربد",
          balqa: "البلقاء",
          mafraq: "المفرق",
          jerashOrAjloun: "جرش / عجلون",
          madaba: "مادبا",
          karak: "الكرك",
          maan: "معان",
          tafilah: "الطفيلة",
          aqaba: "العقبة",
          outsideOfJordan: "برا الأردن",
          questionsOrComments: "عندك سؤال أو ملاحظة؟ احكيلنا",
          termsAndConditions: "الشروط والأحكام",
          privacyPolicy: "سياسية الخصوصية",
          addToHomescreen: "إضافة إلى الشاشة الرئيسية",
          share: "مشاركة الموقع",
          whatsappPermission: "رح نحكي معك على الواتساب عن ملاحظتك",
          contactFooter: "بدك تحكي عن إشي سمعته هون؟",
          contactResponseDelay: "اعطينا لحد 5 أيام وبنرد عليك"
        },
      },
    },
  });

export default i18n;
